module.exports = __webpack_public_path__ + "img/fist-bump.657d8599.svg";